import type { DoctorSpeciality } from '~/api/generated';

export const useDoctorSpecialityStore = defineStore('doctor-speciality', {
  state: () => ({
    loading: false,
    doctorSpecialities: [] as DoctorSpeciality[]
  }),
  getters: {
    getDoctorSpecialityById:
      (state) =>
      (id: DoctorSpeciality['id']): DoctorSpeciality | null =>
        state.doctorSpecialities.find((speciality) => speciality.id === id) || null
  },
  actions: {
    async getDoctorSpecialities() {
      const apiStore = useApiStore();

      this.loading = true;

      try {
        const doctorSpecialities = await apiStore.api.doctorSpecialities.doctorSpecialityList();

        if (doctorSpecialities) {
          this.doctorSpecialities = doctorSpecialities;
        }
      } finally {
        this.loading = false;
      }
    }
  },
  persist: {
    storage: persistedState.localStorage,
    omit: ['loading']
  }
});
